module.exports = __webpack_public_path__ + "img/calendar-16_fill.e1113982.svg";